<template>
  <div>
    <div style="margin-top: 50px;margin-left: 10%;margin-right: 10%;margin-bottom: 50px;">
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">分类：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup v-model="publish" type="button" @on-change="radioPublish(publish)">
          <Radio label="全部"></Radio>
          <Radio label="生活服务"></Radio>
          <Radio label="房屋出租"></Radio>
          <Radio label="技术转让"></Radio>
          <Radio label="兼职招聘"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">价格：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <RadioGroup>
          <Radio label="0-100"></Radio>
          <Radio label="100-200"></Radio>
          <Radio label="200-500"></Radio>
          <Radio label="500-1000"></Radio>
          <Radio label="1000+"></Radio>
        </RadioGroup>
        </Col>
      </Row>
      <Row style="margin-top: 20px">
        <Col span="4" style="text-align: right">
        <span style="font-size: 20px;flood-color: #ed4014">上架时间：</span>
        </Col>
        <Col span="20" style="text-align: left">
        <DatePicker type="daterange" placement="bottom-end" placeholder="Select date" style="width: 200px"></DatePicker>
        </Col>
      </Row>
      <Row align="middle" style="margin-top: 100px;">
        <Col span="8">
        <div style="text-align:center">
          <a @click="changePublish01"><img style="width: 300px;height: 300px;" src="#"/>
          </a>
        </div>
        </Col>
      </Row>
      <Row>
        <Col span="8">
        <a @click="changePublish01" style="font-family: 楷体;font-size: 20px;font-weight: bold">免费Ps修图 新人练手 欢迎联系</a>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data () {
      return {
        publish:"全部",
      }
    },
    mounted () {

    },
    methods:{
      changePublish01(){
        this.$router.push({path:'/publish01'})
      },
      changePublish02(){
        this.$router.push({path:'/publish02'})
      },
      changePublish03(){
        this.$router.push({path:'/publish03'})
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:link{
    color:black;
  }
  a:hover{
    color:red;
  }
  a:active{
    color:darkred;
  }
  .image-into{
    padding:10px;
  }
  .image-out{
    padding:0px;
  }
  .demo-split{
    height: 200px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 200px;
    padding: 0;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .govm-ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    /*background: url("../../assets/images/home_pic.png") no-repeat -87px -31px;*/
    position: relative;
    top: 4px;
    right: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NeedPublish.vue